import React from 'react';

const InlineLoader = ({ loading }) => {

    if (!loading) {
        return (
            <>
            </>
        )

    }
    return (
        <>

            <div className="page-loader-component inline">
                <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>

        </>
    );
}
export default InlineLoader;